import React from 'react';
import { Icon } from 'components';
import './DetailsDrawer.scss';

export const DetailsDrawer = ({
  isOpen,
  onClose,
  title = 'Details',
  icon = 'File_Document',
  children,
  width = '450px',
  position = 'left',
  showBackdrop = true,
  closeOnBackdropClick = true,
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = () => {
    if (closeOnBackdropClick) {
      onClose();
    }
  };

  return (
    <>
      {showBackdrop && (
        <div className='drawer-backdrop' onClick={handleBackdropClick} />
      )}
      <div className={`drawer-overlay drawer-${position}`} style={{ width }}>
        <div className='drawer-panel'>
          <div className='panel-header'>
            <div className='header-content'>
              {icon && <Icon name={icon} size='sm' className='me-2' />}
              <h5 className='mb-0'>{title}</h5>
            </div>
            <button
              className='btn btn-sm btn-link text-white p-0'
              onClick={onClose}
              title='Close'
            >
              <Icon name='Close_LG' />
            </button>
          </div>

          <div className='panel-body'>{children}</div>
        </div>
      </div>
    </>
  );
};
